import { useEffect, useState } from "react";
import Loader from "../../Loader";
import CandidateInfoList from "./CandidateInfoList";
import CandidateInfoSideNavigation from "./CandidateInfoSideNavigation";
import CandidateInfoListItem from "./CandidateInfoListItem";
import CandidateSocialButtons from "./CandidateSocialButtons";
import styles from "../../../styles/candidate/parts/CandidateInfoSection.module.scss";

const CandidateInfoSection = ({
  type,
  anchor,
  data,
  headline,
  profileScoopPosition,
  url,
  contestName,
  candidacyId,
}) => {
  const [selectedKey, setSelectedKey] = useState("0_0");
  const [requiresReset, setRequiresReset] = useState(false);
  const [hasItems, setHasItems] = useState(false);

  useEffect(() => {
    setHasItems(data?.items?.length > 0);
  }, [data]);

  useEffect(() => {
    setSelectedKey("0_0");
  }, [url]);

  const getTabbedItems = () => {
    const results = [];

    data.items?.map((item, index) => {
      let isCategory = false;

      const childItems = item.content?.reduce((children, child, childIndex) => {
        if (child.label) {
          isCategory = true;

          const childItem = {
            key: child.id || `${index}_${childIndex}`,
            label: child.label,
            content: child.content,
            category: item.label,
            isCategory: false,
          };

          children.push(childItem);
        }

        return children;
      }, []);

      results.push({
        key: item.id || isCategory ? `${index}` : `0_${index}`,
        label: item.label,
        content: childItems?.length ? childItems : item.content,
        isCategory,
      });

      childItems?.map((childItem) => {
        if (!childItem || !childItem.label) {
          return;
        }

        results.push(childItem);
      });
    });

    return results;
  };

  const sectionItems = () => {
    switch (type) {
      case "stances":
        return getTabbedItems();
      case "promises":
        return data.items.map((item, index) => {
          item.key = `0_${index}`;
          return item;
        });
      case "highlightsControversies":
      case "topQuestions":
        return getTabbedItems();
      default:
        return [];
    }
  };

  const selectItem = (key) => {
    setSelectedKey(key);
    scrollToSection(key);
    setRequiresReset(true);
  };

  const scrollToSection = (key) => {
    if (type === "highlightsControversies") {
      document.getElementById(`highlights-${key}`).scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    }
  };

  const selectedItem =
    sectionItems().find((item) => item.key === selectedKey) ||
    sectionItems().find((item) => item.key === "0_0");

  const loader = ({ src, width, quality }) => {
    return `${src}?w=${width}&q=${quality || 75}`;
  };

  return hasItems ? (
    <div id={anchor} className={styles.candidateInfoSectionWrapper}>
      <div className={styles.candidateInfoSectionHeader}>
        <h4
          className={
            type === "topQuestions"
              ? styles.smallHeadline
              : styles.mediumHeadline
          }
        >
          {headline.toUpperCase()}
        </h4>
        <CandidateSocialButtons
          containerStyle={styles.socialsContainer}
          iconContainerStyle={styles.socialsContainer_img}
          loader={loader}
          url={url}
          anchor={anchor}
          toolTipId={"toolTip_Default"}
        />
      </div>
      {profileScoopPosition && profileScoopPosition === "top" && (
        <CandidateInfoListItem type={"profileScoop"} data={data} />
      )}
      <div className={styles.sectionBodyWrapper}>
        <CandidateInfoSideNavigation
          items={sectionItems()}
          selectedKey={selectedKey}
          onItemSelect={selectItem}
        />
        <div className={styles.sectionListWrapper}>
          {type === "highlightsControversies" ? (
            <CandidateInfoList
              data={data}
              activeKey={selectedKey}
              items={{
                content: sectionItems().filter((item) => !item.isCategory),
              }}
              type={type}
            />
          ) : (
            <CandidateInfoList
              data={data}
              activeKey={selectedKey}
              items={selectedItem}
              type={type}
              contestName={contestName}
              candidacyId={candidacyId}
            />
          )}
        </div>
      </div>
      {profileScoopPosition && profileScoopPosition === "bottom" && (
        <CandidateInfoListItem type={"profileScoop"} data={data} />
      )}
    </div>
  ) : !hasItems ? null : (
    <Loader />
  );
};

export default CandidateInfoSection;
